(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["black-friday-countdown"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('aw-bf-countdown')) {
customElements.define('aw-bf-countdown', class extends HTMLElement {
connectedCallback() {
this.stop();
const initialize = () => {
const timer = this.querySelector('.aw-bf__timer');
const status = this.querySelector('.aw-bf__status');
if (this.dataset.enabled !== 'true') return;
const [year,month,day] = this.dataset.date.split('-').map(Number);
const hour=Number(this.dataset.hour),minute=Number(this.dataset.minute);
const nominal=Date.UTC(year,month-1,day,hour,minute);
if (!Number.isFinite(nominal)) return;
const formatter=new Intl.DateTimeFormat('en-GB',{timeZone:'Pacific/Auckland',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'});
const partsAt=timestamp=>Object.fromEntries(formatter.formatToParts(new Date(timestamp)).filter(part=>part.type!=='literal').map(part=>[part.type,Number(part.value)]));
let end=nominal;
for(let i=0;i<3;i++){const p=partsAt(end);end+=nominal-Date.UTC(p.year,p.month-1,p.day,p.hour,p.minute,p.second);}
const p=partsAt(end);
if(p.year!==year||p.month!==month||p.day!==day||p.hour!==hour||p.minute!==minute)return;
if(!timer||!status||!Number.isFinite(end))return;
const units=['days','hours','minutes','seconds'].map(unit=>this.querySelector('[data-unit="'+unit+'"]'));
const update=()=>{
const remaining=Math.max(0,Math.ceil((end-Date.now())/1000));
const values=[Math.floor(remaining/86400),Math.floor(remaining/3600)%24,Math.floor(remaining/60)%60,remaining%60];
units.forEach((unit,index)=>{unit.textContent=String(values[index]).padStart(2,'0');});
timer.hidden=remaining===0;status.hidden=remaining>0;
if(remaining===0){status.textContent=this.dataset.expired;this.querySelector('h2').hidden=true;this.querySelector('.aw-bf__eyebrow').hidden=true;this.querySelector('.aw-bf__intro').hidden=true;this.stop();}
return remaining>0;
};
if(update())this.interval=setInterval(update,1000);
};
this.startup=setTimeout(initialize,0);
}
stop(){clearInterval(this.interval);clearTimeout(this.startup);}
disconnectedCallback(){this.stop();}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vela-template-article"]) return;
  try {
    
    (function(d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s); js.id = id;
        js.src = 'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v2.12';
        fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));


  } catch(e) { console.error(e); }
})();
})();
